import classnames from 'classnames';
import React, { FC } from 'react';

import { Tabs } from '@eika/tabs';

import { ExpandTableProps, ExpandTableRow } from './ExpandTable';
import ExpandTableMobileItem from './ExpandTableMobileItem';

import './ExpandTableMobile.scss';

const ExpandTableTabList = ({ tableRows }: { tableRows: ExpandTableRow[] }) => {
    return (
        <Tabs.TabList>
            {tableRows.map((row) => (
                <Tabs.TabButton withUnderline value={row.id} key={row.id}>
                    {row.rowElements[0]}
                </Tabs.TabButton>
            ))}
        </Tabs.TabList>
    );
};
const ExpandTableMobile: FC<ExpandTableProps> = ({ tableHeader, tableRows, className }) => {
    return (
        <div className={classnames('sgw-expand-table-mobile', className)}>
            <Tabs defaultValue={tableRows[0].id}>
                <ExpandTableTabList tableRows={tableRows} />
                {tableRows.map((row) => (
                    <Tabs.Tab value={row.id} key={row.id}>
                        <table>
                            <thead>
                                <tr className="screen-reader-text">
                                    {tableHeader.map((headerElement) => (
                                        <th key={headerElement.id}>{headerElement.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            {row.subTable.length > 0 && (
                                <tbody>
                                    {row.subTable.map((subRow) => (
                                        <ExpandTableMobileItem
                                            tableHeader={tableHeader}
                                            rowElements={subRow.rowElements}
                                            key={subRow.id}
                                        />
                                    ))}
                                </tbody>
                            )}
                            <tbody>
                                <ExpandTableMobileItem tableHeader={tableHeader} rowElements={row.rowElements} />
                            </tbody>
                        </table>
                    </Tabs.Tab>
                ))}
            </Tabs>
        </div>
    );
};

export default ExpandTableMobile;
